import React from 'react';

export class ObservedItem extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(
      this.props.handleIntersection,
      this.props.intersectionOptions
    );
    if (this.ref.current) {
      this.observer.observe(this.ref.current);
    }
  }

  render() {
    const res = (
      <div className={this.props.contClass} ref={this.ref}>
        <div className={this.props.itemClass}>{this.props.children}</div>
      </div>
    );
    return res;
  }
}
